// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.PowerButtonModal_info-box__2jEWX {
  display: flex;
  flex-direction: row;
}
.PowerButtonModal_info-box__2jEWX .PowerButtonModal_descriptor-side__QbJ5i {
  width: 50%;
  font-weight: bold;
}
.PowerButtonModal_info-box__2jEWX .PowerButtonModal_data-side__3V83e {
  text-align: end;
}

.PowerButtonModal_text-box__XrrTm {
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  align-items: center;
}
.PowerButtonModal_text-box__XrrTm .PowerButtonModal_icon__hO-eR {
  width: 2rem;
  height: 2rem;
}
.PowerButtonModal_text-box__XrrTm .PowerButtonModal_content__yYMkx {
  margin: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/NodeInfo/PowerButtonModal.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACrBA;EACE,aAAA;EACA,mBAAA;AAaF;AAXE;EACE,UAAA;EAEA,iBAAA;AAYJ;AAVE;EACE,eAAA;AAYJ;;AARA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAWF;AATE;EACE,WAAA;EACA,YAAA;AAWJ;AARE;EACE,YAAA;AAUJ","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.info-box {\n  display: flex;\n  flex-direction: row;\n}\n.info-box .descriptor-side {\n  width: 50%;\n  font-weight: bold;\n}\n.info-box .data-side {\n  text-align: end;\n}\n\n.text-box {\n  display: flex;\n  flex-direction: row;\n  margin-top: 1rem;\n  align-items: center;\n}\n.text-box .icon {\n  width: 2rem;\n  height: 2rem;\n}\n.text-box .content {\n  margin: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info-box": `PowerButtonModal_info-box__2jEWX`,
	"descriptor-side": `PowerButtonModal_descriptor-side__QbJ5i`,
	"data-side": `PowerButtonModal_data-side__3V83e`,
	"text-box": `PowerButtonModal_text-box__XrrTm`,
	"icon": `PowerButtonModal_icon__hO-eR`,
	"content": `PowerButtonModal_content__yYMkx`
};
export default ___CSS_LOADER_EXPORT___;
